/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M10.5 9A.75.75 0 0 0 9 9v4.5H4.5a.75.75 0 0 0 0 1.5H9v4.5a.75.75 0 0 0 1.5 0V15H15a.75.75 0 0 0 0-1.5h-4.5V9Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 3.75C3 1.679 4.679 0 6.75 0h13.5C22.3211 0 24 1.679 24 3.75v13.5c0 2.0711-1.6789 3.75-3.75 3.75h-.825c-.3475 1.7117-1.8608 3-3.675 3h-12C1.679 24 0 22.3211 0 20.25v-12c0-1.8142 1.2883-3.3275 3-3.675V3.75Zm15 16.5c0 1.2426-1.0074 2.25-2.25 2.25h-12c-1.2426 0-2.25-1.0074-2.25-2.25v-12C1.5 7.0074 2.5074 6 3.75 6h12C16.9926 6 18 7.0074 18 8.25v12ZM15.75 4.5H4.5v-.75c0-1.2426 1.0074-2.25 2.25-2.25h13.5c1.2426 0 2.25 1.0074 2.25 2.25v13.5c0 1.2426-1.0074 2.25-2.25 2.25h-.75V8.25c0-2.071-1.6789-3.75-3.75-3.75Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'Duplicate'
);
